var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSpeaker = function SvgSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.6 46.9 99.8 129H15c-8.3 0-15 6.7-15 15v224c0 8.3 6.7 15 15 15h84.8l134.8 82.1c30 18.3 68.4-3.3 68.4-38.4V85.4c0-35.1-38.4-56.7-68.4-38.5zM30 159h59v194H30V159zm243 267.6c0 11.7-12.8 18.9-22.8 12.8L119 359.6V152.4l131.2-79.9c10-6.1 22.8 1.1 22.8 12.8v341.3zM345.7 217.1c-5.9 5.9-5.9 15.4 0 21.2 9.8 9.8 9.8 25.6 0 35.4-5.9 5.9-5.9 15.4 0 21.2 5.9 5.9 15.4 5.9 21.2 0 21.4-21.4 21.4-56.3 0-77.8-5.9-5.8-15.4-5.8-21.2 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M412.1 171.9c-5.9-5.9-15.4-5.9-21.2 0-5.9 5.9-5.9 15.4 0 21.2 34.7 34.7 34.7 91.2 0 125.9-5.9 5.9-5.9 15.4 0 21.2 5.9 5.9 15.4 5.9 21.2 0 46.4-46.5 46.4-121.9 0-168.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M457.4 126.6c-5.9-5.9-15.4-5.9-21.2 0-5.9 5.9-5.9 15.4 0 21.2 60.7 60.7 60.7 155.7 0 216.4-5.9 5.9-5.9 15.4 0 21.2 5.9 5.9 15.4 5.9 21.2 0 72.8-72.8 72.8-185.9 0-258.8z"
  })));
};

export default SvgSpeaker;